import { Box, Grid, Typography } from '@mui/material'

import { useField } from 'formik'

import RadioField from 'components/atoms/fields/RadioField'

const LearningStyleList = ({ fieldProps, activeIndex }) => {
  const [field] = useField(fieldProps.name)
  const currentQuestion = field?.value?.filter((question) => question.number === activeIndex + 1)[0]
  const options =
    currentQuestion &&
    currentQuestion?.answer_options?.map((answer) => {
      return {
        label: answer.text,
        value: answer.id,
      }
    })

  return (
    <>
      <Box sx={{ width: '100%',  padding: '1rem' }}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography sx={{ fontWeight: 'bold' }}>{`${currentQuestion?.text}`}</Typography>
          </Grid>
          <Grid item xs={12} sx={{ marginBottom: '0.5rem', display: 'flex' }}>
            <RadioField
              fieldProps={{
                label: '',
                name: `${fieldProps.name}[${activeIndex}].answer`,
                required: true,
              }}
              options={options}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default LearningStyleList
